import React from "react";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";

export const DataType = {
    MEMBER:"MEMBER",
    CLAIMANT:"CLAIMANT",
    TRANSACTION:"TRANSACTION",
    RELATIONSHIP:"RELATIONSHIP"
}

export default ({
    label,
    value,
    onChange,
    optionsList,
    loading,
    open,
    setOpen,
    dataType
}) => {

    const renderOptionLabel = (option) => {

        if (dataType === DataType.CLAIMANT) {
            return option ? option.fullName: "";

        } else if (dataType === DataType.MEMBER) {
            return option ? option.membershipId + ". " + option.fullName: "";

        }else if (dataType === DataType.TRANSACTION || dataType === DataType.RELATIONSHIP) {
            return option ? option.name : "";

        }
    }

    return(

        <Autocomplete
            style={{marginBottom: "10px", marginTop: "10px" }}
            open={open}
            fullWidth
            onOpen={ () => setOpen(true) }
            onClose={() => setOpen(false) }
            getOptionSelected={(option, value) => option.name === value.name}
            getOptionLabel={(option) =>  renderOptionLabel(option)}
            options={optionsList}
            loading={loading}
            value={value}
            onChange={(event, newValue) => {
                console.log("new value returned in autocomplete", newValue);
                onChange(newValue) 
            }}
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    label= {label}
                    variant="outlined"
                    InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <React.Fragment>
                            {loading ? (
                                <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                        </React.Fragment>
                    ),
                    }}
                />
            )}
        />

    );
}